export const VERSION = 1;

export const PRODUCTION_ENDPOINT = 'api.anime.fans';
export const STAGING_ENDPOINT = 'api.anime.fans';
const API_PROTO = process.env.NODE_ENV === 'development' ? 'https' : 'https';

export const API_URL_PRODUCTION = `${API_PROTO}://${PRODUCTION_ENDPOINT}`;
export const API_URL_STAGING = `${API_PROTO}://${STAGING_ENDPOINT}`;
